<div class="expand-image-wrapper">
    <div class="container">
        <div class="row">
            <div class="col-12 img-container p-0">
                <div>
                    <img src="{{data?.storeImage}}"  (error)="data.storeImage ='assets/icon/stbplaceholderlg.svg'" class="img-fluid bck-img" alt="store-image">
                </div>
                <div class="logo d-flex justify-content-center" *ngIf="data.storeImage == ''">
                    <img src="assets/icon/stbplaceholderlg.svg" alt="Logo" class="logo-img">
                </div>
                <img src="assets/icon/clear-white.svg" class="close pointer" alt="close"
                    (click)="closeDialog();crossBtnGA()">
            </div>
        </div>
    </div>
</div>